import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectModifyOrganizationTargetId } from '../selectors/organizationChart.selectors';
import { patchUpdateProjectOrganizationStatus } from '../services/patchUpdateProjectOrganizationStatus.service';

export const approveProjectOrganization = createAsyncThunk(
  'organizationCharts/approveProjectOrganization',
  async (_, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const selectModificationTargetId = selectModifyOrganizationTargetId(
      getState()
    );

    const response = await patchUpdateProjectOrganizationStatus(
      selectedProjectId,
      selectModificationTargetId,
      'APPROVED'
    );

    return response;
  }
);
